function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoResultFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120.331,
  height: 121.245,
  viewBox: "452.64 207.131 120.331 121.245"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4150"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.75 33.008h26.258V6.75H6.75zm39.388 78.775H72.4V85.525H46.138zm-39.388 0h26.258V85.525H6.75zm0-39.388h26.258V46.138H6.75zm39.388 0H72.4V46.138H46.138zM85.525 6.75v26.258h26.258V6.75zM46.138 33.008H72.4V6.75H46.138zM85.525 72.4h26.258V46.138H85.525zm0 39.388h26.258V85.525H85.525z",
  "data-name": "Icon ionic-md-apps",
  style: {
    fill: "rgba(251,149,0,.24)"
  },
  transform: "matrix(.7809 0 0 .77349 447.37 201.91)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.384 66.173h-4.472l-1.679-1.4a37.1 37.1 0 0 0 8.667-23.83 36.2 36.2 0 1 0-36.06 36.443A37.46 37.46 0 0 0 64.6 68.7l1.676 1.4v4.484l27.953 28.033 8.386-8.41zm-33.544 0A25.23 25.23 0 1 1 66 40.943a25.09 25.09 0 0 1-25.16 25.23",
  "data-name": "Icon ionic-md-search",
  style: {
    fill: "#fee6c3"
  },
  transform: "matrix(.7809 0 0 .77349 492.838 249.003)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 799"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 4",
  style: {
    stroke: "#fff",
    fill: "#f3594e",
    strokeWidth: 5
  },
  transform: "matrix(.7809 0 0 .77349 505.032 261.08)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25.42,
  cy: 25.42,
  r: 25.42,
  stroke: "none",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.42,
  cy: 25.42,
  r: 27.92,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 798",
  transform: "matrix(.7809 0 0 .77349 -68.154 -7.675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M715.722-4758.285v17.18",
  "data-name": "Path 1752",
  style: {
    strokeLinecap: "round",
    strokeWidth: 6,
    fill: "none",
    stroke: "#fff"
  },
  transform: "translate(43.237 5116.746)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  "data-name": "Ellipse 38",
  style: {
    fill: "#fff"
  },
  transform: "translate(756 382)"
})))));
export { SvgNoResultFound as ReactComponent };
export default __webpack_public_path__ + "images/no-result-found.2fd4c35d.svg";